export const isMonthlyPurchaseAvailableList = [
  {
    id: 1,
    name: 'app.contract.productType.all',
  },
  {
    id: 2,
    name: 'app.contract.productType.year',
  },
];

export const isBA = [
  {
    id: 1,
    name: 'app.yes',
    value: true,
  },
  {
    id: 2,
    name: 'app.no',
    value: false,
  },
];

export const purchaseMethodsEdit = [
  {
    id: 'PROFILE',
    name: 'app.contract.purchaseMethod.profile',
  },
  {
    id: 'PROFILE+SPOT',
    name: 'app.contract.purchaseMethod.profileSpot',
  },
];
